import { Logo } from "@/assets/logo";

/**
 * levelsRx logo (the logo-new.svg artwork, rendered from `@/assets/logo` as an
 * inline SVG so it scales crisply). `theme="dark"` paints the wordmark white for
 * the navy footer; the default light theme keeps the navy mark for headers.
 */
export const FunnelBrand = ({
  theme = "light",
  className = "w-40",
}: {
  theme?: "light" | "dark";
  className?: string;
}) => <Logo theme={theme} className={className} />;

/**
 * "Featured coverage in" badge cluster shown next to the wordmark in the header.
 * Publisher names are rendered as styled text placeholders for their logos.
 */
export const FunnelCoverageBadges = () => (
  <div className="hidden items-center gap-3 sm:flex">
    <div className="flex flex-col items-center leading-tight">
      <span className="text-[10px] font-semibold tracking-wide text-primary-950 uppercase">
        Featured
      </span>
      <span className="text-[10px] font-semibold tracking-wide text-primary-950 uppercase">
        Coverage in
      </span>
      <span className="text-xs text-secondary-500">★★★★★</span>
    </div>
    <div className="flex flex-col items-center gap-0.5 leading-tight">
      <span className="font-serif text-base font-bold text-primary-950">
        Forbes
      </span>
    </div>
  </div>
);
